//basic
import React from 'react';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';

//api
import { api } from '../../../functions/api';

//custom components
import CustomInput from '../../../components/basic/input';
import CustomButton from '../../../components/basic/CustomButton';
// import CustomAvatar from '../../../components/basic/customAvatar';
// import SelectSearch from '../../../components/basic/SelectSearch/SelectSearch';

//material-ui
import { Dialog, DialogTitle, DialogContent, DialogActions, FormControl, InputLabel, MenuItem, Select, Button, CircularProgress, Grid, createMuiTheme, MuiThemeProvider } from '@material-ui/core';

//style
import './EditCustomer.scss';

const theme = createMuiTheme({
    typography: {
        useNextVariants: true
    },
    overrides: {
        MuiFormControl: {
            root: {
                width: "100%",
            }
        },
        MuiFormLabel: {
            root: {
                color: "rgba(0, 0, 0, 0.54) !important"
            },
            focused: {
                color: "rgba(0, 0, 0, 0.54) !important"
            }
        },
        MuiInput: {
            underline: {
                "&:after": {
                    borderBottomColor: "rgba(0, 0, 0, 0.54) !important"
                }
            }
        }
    }
})


@inject('translate')
@inject('internal')
@observer
export default class EditCustomer extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            loadingBtn: false,
            loading: true,
            data: {}
        }
    }

    componentDidMount () {
        // let allCustomers = toJS(this.props.internal.dataForTable.data)
        // let customerForEdit = allCustomers.find(item => item.id === toJS(this.props.internal.actionEdit.id))
        // this.setState({data: customerForEdit, loading: false})
        let actionEdit = toJS(this.props.internal.actionEdit)

        if(actionEdit.id !== null) {
            Promise.all([
                this.loadCustoemrDetail(actionEdit.id ),
                // this.loadCountries()
            ]).then(() => {
                this.setState({loading: false})
            })
            
        }
        else {
            Promise.all([
                // this.loadCountries()
            ]).then(() => {
                this.setState({loading: false})
            })
        }
        
    }

    loadCustoemrDetail = async(idCustomer) => {
        let load_data = await api({
            method: 'get',
            url: `customers/${idCustomer}`,
            authorization: this.props.internal.user.access_token,
        })

        if(load_data.success === true) {
            this.setState({data: load_data.data.data})
        }
    }

    action = () => {
        this.setState({loadingBtn: true})
        this.updateCustomerData()
    }

    updateCustomerData = async() => {
        let idCustomer = toJS(this.props.internal.actionEdit.id)

        let data = {}
        if(this.billing_city.state.value !== "") {
            data.billing_city = this.billing_city.state.value
        }

        if(this.state.data.data.billing_country_id) {
            data.billing_country_id = this.state.data.data.billing_country_id
        }

        // if(this.billing_country_id.state.value !== "") {
        //     data.billing_country_id = this.billing_country_id.state.value
        // }

        // if(this.billing_email.state.value !== "") {
        //     data.billing_email = this.billing_email.state.value
        // }

        if(this.billing_phone.state.value !== "") {
            data.billing_phone = this.billing_phone.state.value
        }

        if(this.billing_street.state.value !== "") {
            data.billing_street = this.billing_street.state.value
        }

        if(this.billing_zip.state.value !== "") {
            data.billing_zip = this.billing_zip.state.value
        }

        if(this.delivery_city.state.value !== "") {
            data.delivery_city = this.delivery_city.state.value
        }

        if(this.state.data.data.delivery_country_id) {
            data.delivery_country_id = this.state.data.data.delivery_country_id
        }

        // if(this.delivery_country_id.state.value !== "") {
        //     data.delivery_country_id = this.delivery_country_id.state.value
        // }

        // if(this.delivery_email.state.value !== "") {
        //     data.delivery_email = this.delivery_email.state.value
        // }

        if(this.delivery_phone.state.value !== "") {
            data.delivery_phone = this.delivery_phone.state.value
        }

        if(this.delivery_street.state.value !== "") {
            data.delivery_street = this.delivery_street.state.value
        }

        if(this.delivery_zip.state.value !== "") {
            data.delivery_zip = this.delivery_zip.state.value
        }

        let params = {
            first_name: this.first_name.state.value,
            last_name: this.last_name.state.value,
            email: this.email.state.value,
            data: data
        }

        let update_data = await api({
            method: 'patch',
            url: `customers/${idCustomer}`,
            authorization: this.props.internal.user.access_token,
            params: params
        })

        if (update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
            this.props.onClose(true)
        } else {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
        
        this.setState({loadingBtn: false})
    }


    handleChangePhoto = async (data) => {

        let idFixedSet = toJS(this.props.internal.actionEdit.id)

        if(idFixedSet !== null) {
            this.setState({loadingBtn: true})
            let upload_data = await api({
                method: 'post',
                url: `products/static-sets/${idFixedSet}`,
                formData: true,
                authorization: this.props.internal.user.access_token,
                params: {
                    photo: data
                },

            })
            
            if (upload_data.success && upload_data.success === true) {
                // this.props.internal.photoWasChanged(false)
                this.props.internal.setSnackbar(upload_data.data.message, true)
                this.setState({loadingBtn: false})
                
                return Promise.resolve(false)
            }
            else {
                this.props.internal.setSnackbar(upload_data.data.message, true)
            }
        }
        else {

        }
    }

    handleCountry = (field, val) => {
        let tmpData = this.state.data
        tmpData.data[field] = val.target.value
        this.setState({data: tmpData})
    }

    render() {
        return (
            <MuiThemeProvider theme={theme}>
            <Dialog
                open={this.props.open}
                onClose={() => this.props.onClose(false)}
                aria-labelledby="form-dialog-title"
                classes={{
                    root: "addEditFixedSetDialog-root",
                    paper: "addEditFixedSetDialog-paper"
                }}
            >
                <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
                {this.state.loading
                ?
                <div style={{minHeight: "100px"}}>
                    <CircularProgress className={'circular-progress'} />
                </div>
                :
                <DialogContent classes={{root: "updateCustomer"}}>
                    <Grid container spacing={8}>
                        <Grid item xs={12} sm={6}>
                            <CustomInput
                                ref={ref => this.first_name = ref}
                                text={this.props.translate.i18n.MODULES.CUSTOMERS.FIRST_NAME}
                                value={this.state.data.first_name}
                                id={'first_name'}
                                className={"w-100"}
                                change={this.handleChangeData}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <CustomInput
                                ref={ref => this.last_name = ref}
                                text={this.props.translate.i18n.MODULES.CUSTOMERS.LAST_NAME}
                                value={this.state.data.last_name}
                                id={'last_name'}
                                className={"w-100"}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <CustomInput
                                ref={ref => this.email = ref}
                                text={this.props.translate.i18n.GLOBAL.CONTACT.EMAIL}
                                value={this.state.data.email}
                                id={'email'}
                                className={"w-100"}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                        
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Grid container>
                                <Grid item xs={12} >
                                    <h2 className={'titleAddress'}>{this.props.translate.i18n.MODULES.CUSTOMERS.BILLING_ADDRESS}</h2>
                                </Grid>
                                {/* <Grid item xs={12}>
                                    <CustomInput
                                        ref={ref => this.billing_email = ref}
                                        text={this.props.translate.i18n.GLOBAL.CONTACT.EMAIL}
                                        value={this.state.data.data !== null ? this.state.data.data.billing_email : ""}
                                        id={'billing_email'}
                                        className={"w-100"}
                                    />
                                </Grid> */}
                                <Grid item xs={12}>
                                    <CustomInput
                                        ref={ref => this.billing_phone = ref}
                                        text={this.props.translate.i18n.GLOBAL.CONTACT.PHONE}
                                        value={this.state.data.data !== null ? this.state.data.data.billing_phone : ""}
                                        id={'billing_phone'}
                                        className={"w-100"}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomInput
                                        ref={ref => this.billing_street = ref}
                                        text={this.props.translate.i18n.GLOBAL.ADRESS.ADRESS}
                                        value={this.state.data.data !== null ? this.state.data.data.billing_street : ""}
                                        id={'billing_street'}
                                        className={"w-100"}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomInput
                                        ref={ref => this.billing_zip = ref}
                                        text={this.props.translate.i18n.GLOBAL.ADRESS.ZIP}
                                        value={this.state.data.data !== null ? this.state.data.data.billing_zip : ""}
                                        id={'billing_zip'}
                                        className={"w-100"}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomInput
                                        ref={ref => this.billing_city = ref}
                                        text={this.props.translate.i18n.GLOBAL.ADRESS.CITY}
                                        value={this.state.data.data !== null ? this.state.data.data.billing_city : ""}
                                        id={'billing_city'}
                                        className={"w-100"}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    {/* <CustomInput
                                        ref={ref => this.billing_country = ref}
                                        text={this.props.translate.i18n.GLOBAL.ADRESS.COUNTRY}
                                        value={this.state.data.data !== null ? this.state.data.data.billing_country : ""}
                                        id={'billing_country'}
                                        className={"w-100"}
                                    /> */}
                                    <FormControl c>
                                        <InputLabel htmlFor="billing_country_id" >{this.props.translate.i18n.GLOBAL.ADRESS.COUNTRY}</InputLabel>
                                        <Select
                                            // className={'multiple-select '}
                                            value={this.state.data.data && this.state.data.data !== null ? this.state.data.data.billing_country_id : 0}
                                            onChange={(val) => this.handleCountry('billing_country_id', val)}
                                            inputProps={{
                                                name: 'billing_country_id',
                                                id: 'billing_country_id',
                                            }}
                                        >
                                        {toJS(this.props.internal.dataForTable.lists.countries).map(country => (
                                            // <MenuItem key={country.id} value={country} title={country.title} >
                                            <MenuItem key={country.id} value={country.id} >
                                                {country.name}
                                            </MenuItem>
                                        ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Grid container>
                                <Grid item xs={12} >
                                    <h2 className={'titleAddress'}>{this.props.translate.i18n.MODULES.CUSTOMERS.DELIVERY_ADDRESS}</h2>
                                </Grid>
                                {/* <Grid item xs={12}>
                                    <CustomInput
                                        ref={ref => this.delivery_email = ref}
                                        text={this.props.translate.i18n.GLOBAL.CONTACT.EMAIL}
                                        value={this.state.data.data !== null ? this.state.data.data.delivery_email : ""}
                                        id={'delivery_email'}
                                        className={"w-100"}
                                    />
                                </Grid> */}
                                <Grid item xs={12}>
                                    <CustomInput
                                        ref={ref => this.delivery_phone = ref}
                                        text={this.props.translate.i18n.GLOBAL.CONTACT.PHONE}
                                        value={this.state.data.data !== null ? this.state.data.data.delivery_phone : ""}
                                        id={'delivery_phone'}
                                        className={"w-100"}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomInput
                                        ref={ref => this.delivery_street = ref}
                                        text={this.props.translate.i18n.GLOBAL.ADRESS.ADRESS}
                                        value={this.state.data.data !== null ? this.state.data.data.delivery_street : ""}
                                        id={'delivery_street'}
                                        className={"w-100"}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomInput
                                        ref={ref => this.delivery_zip = ref}
                                        text={this.props.translate.i18n.GLOBAL.ADRESS.ZIP}
                                        value={this.state.data.data !== null ? this.state.data.data.delivery_zip : ""}
                                        id={'delivery_zip'}
                                        className={"w-100"}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <CustomInput
                                        ref={ref => this.delivery_city = ref}
                                        text={this.props.translate.i18n.GLOBAL.ADRESS.CITY}
                                        value={this.state.data.data !== null ? this.state.data.data.delivery_city : ""}
                                        id={'delivery_city'}
                                        className={"w-100"}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    {/* <CustomInput
                                        ref={ref => this.delivery_country = ref}
                                        text={this.props.translate.i18n.GLOBAL.ADRESS.COUNTRY}
                                        value={this.state.data.data !== null ? this.state.data.data.delivery_country : ""}
                                        id={'delivery_country'}
                                        className={"w-100"}
                                    /> */}
                                    <FormControl c>
                                        <InputLabel htmlFor="delivery_country_id" >{this.props.translate.i18n.GLOBAL.ADRESS.COUNTRY}</InputLabel>
                                        <Select
                                            // className={'multiple-select '}
                                            value={this.state.data.data && this.state.data.data !== null ? this.state.data.data.delivery_country_id : 0}
                                            onChange={(val) => this.handleCountry('delivery_country_id', val)}
                                            inputProps={{
                                                name: 'delivery_country_id',
                                                id: 'delivery_country_id',
                                            }}
                                        >
                                        {toJS(this.props.internal.dataForTable.lists.countries).map(country => (
                                            // <MenuItem key={country.id} value={country} title={country.title} >
                                            <MenuItem key={country.id} value={country.id} >
                                                {country.name}
                                            </MenuItem>
                                        ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>
                    
                    </Grid>
                    
                </DialogContent>
                }
                <DialogActions>
                    <Button onClick={() => this.props.onClose(false)} className={'gray-text'}>
                        {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    <CustomButton
                        progressBar={this.state.loadingBtn}
                        onClick={this.action}
                        mystyle={'btn-white-bg'}
                        title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                        justText
                        disabled={this.state.loading}
                    />
                </DialogActions>
            </Dialog>
            </MuiThemeProvider>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/Customers/Edit/EditCustomer.jsx